import React, { useState, useEffect } from "react";
import { Paragraph } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";
import {default as ImageComponent} from "@project-stories/elements/ExtendedImage/ExtendedImage";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";



const BannerVerticalPositions = {
  top: 'items-start',
  middle: 'items-center',
  bottom:  'items-end'
}

const BannerHorizontalPositions = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
  between: 'justify-center'
}


export const ExtendedBanner = ({ banners, section, useCarousel = true }) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const { image_height_type, image_height, image_height_type_mobile, image_height_mobile } = section;
  const imageHeight = isMobile ? image_height_mobile : image_height;
  const definedHeight = isMobile ? image_height_type_mobile == 'defined' : image_height_type == 'defined';
  const openPreezieGuide = () => {
    if (!PREEZIE_GUIDE) {
      console.log('PREEZIE_GUIDE not found')
      return;
    }
      
    PREEZIE_GUIDE.openPrzCtaGuide()
  };


  const dynamicDesktopHeight =  Math.ceil(window.innerWidth /  Number(banners[0]?.responsive_image_url.aspect_ratio));
  const dynamicMobileHeight = Math.ceil(window.innerWidth /  Number(banners[0]?.responsive_image_url_mobile.aspect_ratio));



  return (
    <div className={`banner  h-[${dynamicMobileHeight}px] lg:h-[${dynamicDesktopHeight}px] ${definedHeight ? `h-[${imageHeight}px]` : ``} `}>
      <div
        className={` ${definedHeight ? `h-[${imageHeight}px]` : `banner__carousel h-[${dynamicMobileHeight}px] lg:h-[${dynamicDesktopHeight}px]`}`}
        {...(useCarousel && {
          'x-data': "carousel",
          'x-init': "$nextTick(() => { initialise(true, false, false) })",
          'x-ref': "carousel",
        })}
      >
        {banners.map((blockItem, index) => {
          const [verticalMobilePosition, horizontalMobilePosition] = blockItem.settings.content_position_mobile.split("_");
          const [verticalDesktopPosition, horizontalDesktopPosition] = blockItem.settings.content_position.split("_");

          const cta_alignment_desktop = blockItem.settings.cta_alignment;
          const cta_alignment_mobile =  blockItem.settings.cta_alignment_mobile;
          const text_alignment_desktop =  blockItem.settings.text_alignment;
          const text_alignment_mobile = blockItem.settings.text_alignment_mobile;
          let space_between = '';
          if (verticalMobilePosition == 'space' && verticalDesktopPosition == 'space') {
            space_between = '!justify-between';
            parent
          }
          else if (verticalMobilePosition == 'space' && verticalDesktopPosition != 'space' ) {
            space_between = '!justify-between lg:justify-center';
          }
          else if (verticalMobilePosition != 'space' && verticalDesktopPosition == 'space'  ) {
             space_between = ' lg:!justify-between';
          }


          return (
            <div key={index}>
              {blockItem.type === "block_image" && (
                <>
                  <div className={`banner__overlay ${BannerVerticalPositions[verticalMobilePosition]} lg:${BannerVerticalPositions[verticalDesktopPosition]} ${BannerHorizontalPositions[horizontalMobilePosition]} lg:${BannerHorizontalPositions[horizontalDesktopPosition]}`}>
                    <div
                      className={`banner__overlay--content w-[${blockItem.settings.mobile_content_width}px] 
                      lg:w-[${blockItem.settings.desktop_content_width}px] py-[${blockItem.settings.mobile_padding}px] 
                      px-[${blockItem.settings.mobile_padding}px] lg:px-[${blockItem.settings.desktop_padding}px] lg:py-[${blockItem.settings.desktop_padding}px] 
                      text-${text_alignment_mobile} 
                      lg:text-${text_alignment_desktop}  ${space_between}
                      `}
                    >
                      <div className="flex flex-col"> 
                      <p
                        className="font-bold h1"
                        style={{ color: `${blockItem.settings.title_color}` }}
                        dangerouslySetInnerHTML={{ __html: blockItem.settings.title }}
                      >
                      </p>
                      <p
                        className={`${blockItem.settings.subtext_style}`}
                        style={{ color: `${blockItem.settings.subtext_color}` }}
                        dangerouslySetInnerHTML={{ __html: blockItem.settings.subtext }}
                      >
                        
                      </p>
                      </div>
                      {blockItem.settings.button_text && (
                        <div className={`button-wrapper flex  ${BannerHorizontalPositions[cta_alignment_mobile]} lg:${BannerHorizontalPositions[cta_alignment_desktop]}`}>
                          {blockItem.settings.is_quiz_trigger ? (
                            <a
                              className={`quiz-button button max-w-max hover:no-underline mt-6 lg:mt-3 ${blockItem.settings.button_style} ${blockItem.settings.show_button_on_desktop === false ? 'block lg:!hidden' : 'block'}`}
                              onClick={() => openPreezieGuide()}
                              style={{ cursor: 'pointer' }}
                            >
                              {blockItem.settings.button_text}
                            </a>
                          ) : (
                            <a
                              href={blockItem.settings.button_url}
                              className={`button max-w-max hover:no-underline mt-6 lg:mt-3 ${blockItem.settings.button_style} ${blockItem.settings.show_button_on_desktop === false ? 'block lg:!hidden' : 'block'}`}
                            >
                              {blockItem.settings.button_text}
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={`w-screen ${definedHeight ? `h-[${imageHeight}px]` : ` h-[${dynamicMobileHeight}px] lg:h-[${dynamicDesktopHeight}px]`} banner__overlay--image content-over-media`}>
                    {blockItem.settings.button_url ||
                    blockItem.settings.button_text ? (
                      <ImageComponent
                        imageUrl={isMobile ?  blockItem.responsive_image_url_mobile && blockItem.responsive_image_url_mobile ?.src : blockItem.responsive_image_url && blockItem.responsive_image_url?.src}
                        classes="absolute top-0 left-0 object-cover w-full h-full"
                        alt={blockItem.settings.title || 'Banner image'}
                        imageUrlSet={isMobile? blockItem.responsive_image_url_mobile && blockItem.responsive_image_url_mobile?.srcset  :  blockItem.responsive_image_url  && blockItem.responsive_image_url?.srcset }
                        highPriority={index === 0}
                        isLazy={index === 0 ? false : true}
                      />
                    ) : (
                      <ImageComponent
                        imageUrl={isMobile ?  blockItem.responsive_image_url_mobile && blockItem.responsive_image_url_mobile ?.src : blockItem.responsive_image_url && blockItem.responsive_image_url?.src}
                        classes="absolute top-0 left-0 flex items-center justify-center object-cover w-full h-full"
                        alt={blockItem.settings.title || 'Banner image'}
                        imageUrlSet={isMobile ? blockItem.responsive_image_url_mobile && blockItem.responsive_image_url_mobile?.srcset  :  blockItem.responsive_image_url  && blockItem.responsive_image_url?.srcset }
                        highPriority={index === 0}
                        isLazy={index === 0 ? false : true}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExtendedBanner;